  // Constants
  let _justAutoAddedGift = false;
  const FREE_GIFT_VARIANT_IDS = [];
  const ENABLE_FREE_GIFT = false;
  const AUTO_ADD_FREE_GIFT = false;
  // guard the handle
  
    const AUTO_ADD_FREE_GIFT_HANDLE = "sextoy-lube-water-based-lubricant";
  
  const FREE_GIFT_PROMOTION_TYPE    = "cart_total";
  const PAIRS_COLLECTION_HANDLE = "pairs-well-with";
  const FREE_SHIPPING_THRESHOLD = 9900; // $99.00 in cents
  const FREE_ITEM_THRESHOLD = ENABLE_FREE_GIFT ? 12500 : null;
  const FREE_ITEM_THRESHOLD_DISPLAY = ENABLE_FREE_GIFT ? 125 : null;
  const RECOMMENDATION_COLLECTION_HANDLE = "cart-recommendations";
  const RECOMMENDATION_COLLECTION_COUNT  = 6;
  const QUALIFYING_COLLECTION_HANDLE = "sextoy-com-collection";

  const PAIRS_WELL_WITH_HANDLES = [
    
  ];
  const QUALIFYING_PRODUCT_IDS = new Set();

  const EXCLUDED_PRODUCT_TYPES = [
    'Club Wear',
    'Fetish Clothing',
    'Men\'s Clothing',
    'Sexy Accessories',
    'Sexy Costumes',
    'Women\'s Lingerie',
    'Anal Lube',
    'Anal Douches',
    'Lingerie & Clothing',
    'Lubricants',
    'Sensual Massage',
    'Oral Sex Products',
    'Condoms',
    'Sex Pills & Enhancers',
    'Self Care & Menstruation',
    'Accessories',
    'Games & Novelty',
    'Storage and Toy Care',
    'Stripper Poles',
    'Clone your own',
    'Books'
  ];

  async function checkAutoAddGift(cart) {
    if (_justAutoAddedGift) {
      _justAutoAddedGift = false;
      return;
    }
    // 1) bail early if not enabled or no product chosen
    if (!AUTO_ADD_FREE_GIFT || !AUTO_ADD_FREE_GIFT_HANDLE) return;

    // 2) don’t double-add
    if (isFreeGiftInCart(cart)) return;

    // 3) check qualification rules
    const qualifiesCart     = cart.total_price >= FREE_ITEM_THRESHOLD;
    const qualifiesCategory = cart.items.some(i => QUALIFYING_PRODUCT_IDS.has(i.product_id));
    const promo = FREE_GIFT_PROMOTION_TYPE;
    const qualifies =
      (promo === 'cart_total'       && qualifiesCart) ||
      (promo === 'product_category' && qualifiesCategory) ||
      (promo === 'both'             && (qualifiesCart || qualifiesCategory));

    if (!qualifies) return;

    // 4) fetch the chosen product by handle
    let variantId;
    try {
      const product = await fetch(`/products/${AUTO_ADD_FREE_GIFT_HANDLE}.js`)
                            .then(r => r.json());
      variantId = product.variants?.[0]?.id;
    } catch (e) {
      console.warn('Auto-add gift: failed to load product', e);
      return;
    }

    if (!variantId) return;

    // 5) finally, add it
    await addFreeGiftToCart(variantId);
  }

  async function fetchCollectionProducts(handle, limit = 6) {
    if (!handle) return [];
    try {
      const { products = [] } = await fetch(
        `/collections/${handle}/products.json?limit=${limit}`
      ).then(r => r.json());
      return Array.isArray(products) ? products : [];
    } catch (err) {
      console.error(`Error fetching collection ${handle}:`, err);
      return [];
    }
  }

  // Open and Close Cart Drawer
  function openCartDrawer() {
      /*if (isIOS()) {
        window.scrollTo({
          top: 0,
          behavior: 'smooth', // Smooth scrolling for better UX
        });
      }*/
      const cartDrawer = document.getElementById('cart-drawer');
      const overlay = document.getElementById('cart-overlay');

      // Open cart drawer and show overlay
      cartDrawer.classList.add('cart-drawer--open');
      overlay.style.display = 'block';

      // Lock background scroll, allowing scroll only within the cart drawer
      ScrollLock.lock(cartDrawer);
  }

  function closeCartDrawer() {
      const cartDrawer = document.getElementById('cart-drawer');
      const overlay = document.getElementById('cart-overlay');

      // Close cart drawer and hide overlay
      cartDrawer.classList.remove('cart-drawer--open');
      overlay.style.display = 'none';

      // Unlock background scroll
      ScrollLock.unlock();
  }

async function initializeSwiper() {
  if (!ENABLE_FREE_GIFT) return;

  const container = document.querySelector('.free-gift-swiper');
  if (!container) return;

  // If Swiper isn't loaded yet, lazy-load it now (JS only).
  // (CSS should NOT be global render-blocking; we'll handle that in theme.liquid)
  if (typeof window.Swiper === 'undefined') {
    await new Promise((resolve, reject) => {
      const s = document.createElement('script');
      s.src = 'https://unpkg.com/swiper/swiper-bundle.min.js';
      s.async = true;
      s.onload = resolve;
      s.onerror = reject;
      document.head.appendChild(s);
    });
  }

  const slidesPerView = 3;
  const realSlides = container.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)').length;

  // Use window.Swiper (safe if global)
  const swiper = new window.Swiper(container, {
    slidesPerView,
    spaceBetween: 10,
    loop: false,
    watchOverflow: true,
    pagination: { el: '.free-gift-pagination', clickable: true },
    navigation: { nextEl: '.free-gift-next', prevEl: '.free-gift-prev' },
    breakpoints: {
      640:  { slidesPerView, spaceBetween: 10 },
      768:  { slidesPerView, spaceBetween: 15 },
      1024: { slidesPerView, spaceBetween: 20 }
    }
  });

  if (realSlides <= slidesPerView) {
    container.classList.add('no-nav');
  }
}



  async function fetchCartContents() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();

      const cartProductIds = cart.items.map(item => item.product_id);

      removeFreeGiftIfNeeded(cart); // Remove free gift if necessary
  
      // Update cart header count
      updateCartHeader(cart);
  
      // Render cart contents
      const cartContentsElement = document.getElementById('cart-drawer-contents');
      cartContentsElement.innerHTML = ''; // Clear existing content
  
      // Always update the progress bar, even if the cart is empty
      updateProgressBar(cart);
  
      if (cart.items.length === 0) {
        renderEmptyCart();
      } else {
        renderCartItems(cart);
        await checkAutoAddGift(cart);
        await initializeSwiper();
        openCartDrawer();
        // Check if cart contains any items not in EXCLUDED_PRODUCT_TYPES
        let hasNonExcludedItems = true; // Default to true in case of error
        try {
          hasNonExcludedItems = await cartContainsNonExcludedItems(cart);
        } catch (error) {
          console.error('Error in cartContainsNonExcludedItems:', error);
        }
   
        if (hasNonExcludedItems) {
          try {
            // Render "Pairs Well With" when cart has non-excluded items
            await renderPairsWellWith(cartProductIds);
          } catch (error) {
            console.error('Error rendering Pairs Well With:', error);
          }
        }
  
        try {
          // Always render Recommendations
          renderRecommendations(cart, cartProductIds);
        } catch (error) {
          console.error('Error rendering Recommendations:', error);
        }
      }
  
    } catch (error) {
      console.error('Error fetching cart contents:', error);
    }
  }  

  function updateCartHeader(cart) {
    const totalQuantity = cart.items.reduce((acc, item) => acc + item.quantity, 0);
    const cartCountElement = document.getElementById('header-cart-count');
    const siteHeaderCartCountElement = document.querySelector('.site-header-cart--count');

    if (cartCountElement) cartCountElement.innerText = totalQuantity;
    if (siteHeaderCartCountElement) {
      siteHeaderCartCountElement.setAttribute('data-header-cart-count', totalQuantity);
      siteHeaderCartCountElement.classList.toggle('visible', totalQuantity > 0);
      siteHeaderCartCountElement.classList.toggle('hidden', totalQuantity === 0);
    }
  }

  function renderEmptyCart() {
    const cartContentsElement = document.getElementById('cart-drawer-contents');
    cartContentsElement.innerHTML += `
      <div class="text-center py-5">
        <p class="h3">Your cart is empty</p>
        <p class="text-muted">Need some suggestions?</p>
        <a href="/collections/top-ten-sex-toys" class="btn btn-secondary mt-3" style="background-color:#124040">Shop Our Best Toys</a>
      </div>
    `;
    // Ensure the progress bar and milestones are displayed when the cart is empty
  }

  function updateProgressBar(cart) {
    // 1) Grab elements & compute totals
    const cartTotal       = cart.total_price;
    const originalTotal   = cart.items.reduce((sum, i) => sum + i.original_line_price, 0);
    const subtotalEl      = document.getElementById('cart-subtotal');
    const subtotalCont    = document.getElementById('cart-subtotal-container');
    const checkoutBtn     = document.getElementById('checkout-button');
    const messageEl       = document.getElementById('free-shipping-message');
    const barEl           = document.getElementById('free-shipping-progress-bar');
    const milestoneShip   = document.getElementById('milestone-shipping');
    const milestoneGift   = document.getElementById('milestone-gift');
    const thresholdEl     = document.getElementById('free-item-threshold');

    // 2) Flags for which modes are active
    const triggerCartTotal       = FREE_GIFT_PROMOTION_TYPE === 'cart_total' || FREE_GIFT_PROMOTION_TYPE === 'both';
    const triggerProductCategory = FREE_GIFT_PROMOTION_TYPE === 'product_category' || FREE_GIFT_PROMOTION_TYPE === 'both';
    const qualifiesCart     = cartTotal >= FREE_ITEM_THRESHOLD;
    const qualifiesCategory = cart.items.some(i => QUALIFYING_PRODUCT_IDS.has(i.product_id));

    // 3) Show the free-item threshold when pricing applies
    if (triggerCartTotal && thresholdEl) {
      thresholdEl.innerText = FREE_ITEM_THRESHOLD_DISPLAY;
    }

    // 4) Always show the bar & checkout footer
    subtotalCont.style.display                   = 'flex';
    document.getElementById('progress-container').style.display = 'flex';
    checkoutBtn.style.display                    = cart.items.length ? 'block' : 'none';

    // 5) Reposition the shipping milestone
    if (milestoneShip) {
      // If free-gift is turned off, push shipping to 98%
      if (!ENABLE_FREE_GIFT) {
        milestoneShip.style.left = '98%';
      }
      // If “both” mode & they qualify by category (but not by cart total), push shipping to 98%
      else if (
        ENABLE_FREE_GIFT &&
        FREE_GIFT_PROMOTION_TYPE === 'both' &&
        qualifiesCategory &&
        !qualifiesCart
      ) {
        milestoneShip.style.left = '98%';
      }
      // Otherwise fall back to our defaults
      else {
        milestoneShip.style.left =
          (FREE_GIFT_PROMOTION_TYPE === 'cart_total' || FREE_GIFT_PROMOTION_TYPE === 'both')
            ? '79%'
            : '98%';
      }
    }

    // 6) Did we unlock a gift by any rule?
    const unlockedGift = ENABLE_FREE_GIFT && (
      (FREE_GIFT_PROMOTION_TYPE === 'cart_total'       && qualifiesCart)    ||
      (FREE_GIFT_PROMOTION_TYPE === 'product_category' && qualifiesCategory) ||
      (FREE_GIFT_PROMOTION_TYPE === 'both'             && (qualifiesCart || qualifiesCategory))
    );

    let message = '';

    // 7) If we've unlocked something—decide which message to show
    if (unlockedGift) {
      // a) If purely product_category mode (or both but only category qualifies)
      if (
        (FREE_GIFT_PROMOTION_TYPE === 'product_category' && qualifiesCategory) ||
        (FREE_GIFT_PROMOTION_TYPE === 'both' && qualifiesCategory && !qualifiesCart)
      ) {
        // They have a free gift. Now check shipping:
        message = `🎉 YOU'VE UNLOCKED <span class="text-success fw-bold">A FREE GIFT!</span>`;
        if (cartTotal < FREE_SHIPPING_THRESHOLD) {
          const remShip = (FREE_SHIPPING_THRESHOLD - cartTotal) / 100;
          message += `<br>YOU’RE ONLY <span class="text-danger fw-bold">$${remShip.toFixed(2)}</span> AWAY FROM <strong>FREE SHIPPING</strong>`;
          barEl.className = 'progress-bar-striped progress-bar-animated bg-danger';
          milestoneShip?.classList.remove('achieved');
        } else {
          // They hit shipping too
          message = `🎉 YOU'VE UNLOCKED <span class="text-success fw-bold">FREE SHIPPING AND A FREE GIFT!</span>`;
          barEl.className = 'progress-bar-striped progress-bar-animated bg-success';
          milestoneShip?.classList.add('achieved');
        }
        // Hide gift pin since category alone doesn't need a $-threshold marker
        if (milestoneGift) {
          milestoneGift.style.display = 'none';
          milestoneGift.classList.remove('achieved');
        }
      }
      // b) Otherwise they meet cart_total (or both & cart_total qualifies)
      else {
        // They have both free shipping and free gift
        message        = `🎉 YOU'VE UNLOCKED <span class="text-success fw-bold">FREE SHIPPING AND A FREE GIFT!</span>`;
        barEl.className = 'progress-bar-striped progress-bar-animated bg-success';
        milestoneShip?.classList.add('achieved');

        if (milestoneGift) {
          // show gift‐threshold pin only when price rule applied
          const showGiftMarker =
            FREE_GIFT_PROMOTION_TYPE === 'cart_total' ||
            (FREE_GIFT_PROMOTION_TYPE === 'both' && qualifiesCart);
          milestoneGift.style.display = showGiftMarker ? 'block' : 'none';
          if (showGiftMarker) milestoneGift.classList.add('achieved');
          else                milestoneGift.classList.remove('achieved');
        }
      }
    }
    // 8) Otherwise → render shipping‐only logic, then “away from gift” hints
    else {
      // a) purely shipping section
      if (cartTotal < FREE_SHIPPING_THRESHOLD) {
        const rem = (FREE_SHIPPING_THRESHOLD - cartTotal) / 100;
        message = `YOU’RE ONLY <span class="text-danger fw-bold">$${rem.toFixed(2)}</span> AWAY FROM <strong>FREE SHIPPING</strong>`;
        barEl.className = 'progress-bar-striped progress-bar-animated bg-danger';
        milestoneShip?.classList.remove('achieved');
      } else {
        message = `🎉 YOU'VE UNLOCKED <span class="text-success fw-bold">FREE SHIPPING!</span>`;
        barEl.className = 'progress-bar-striped progress-bar-animated bg-success';
        milestoneShip?.classList.add('achieved');
      }

      // b) now append “away from gift” hints if free-gift is enabled
      if (ENABLE_FREE_GIFT) {
        // If both rules are active, combine into “AND … Or, …”
        if (triggerCartTotal && triggerProductCategory) {
          const remG = ((FREE_ITEM_THRESHOLD - cartTotal) / 100).toFixed(2);
          const title       = "";
          const href        = `/collections/${QUALIFYING_COLLECTION_HANDLE}`;
          const linkedTitle = `<a href="${href}" class="text-danger text-decoration-underline">${title}</a>`;

          message += `<br>AND <span class="text-danger fw-bold">$${remG}</span> AWAY FROM A <strong>FREE GIFT</strong>`;
          message += `<br>Or, Add any item from <strong>${linkedTitle}</strong> to unlock a <strong>FREE GIFT</strong>`;
        }
        // Only cart_total rule
        else if (triggerCartTotal) {
          const remG = ((FREE_ITEM_THRESHOLD - cartTotal) / 100).toFixed(2);
          message += `<br>AND <span class="text-danger fw-bold">$${remG}</span> AWAY FROM A <strong>FREE GIFT</strong>`;
        }
        // Only product_category rule
        else if (triggerProductCategory) {
          const title       = "";
          const href        = `/collections/${QUALIFYING_COLLECTION_HANDLE}`;
          const linkedTitle = `<a href="${href}" class="text-danger text-decoration-underline">${title}</a>`;
          message += `<br>Add any item from <strong>${linkedTitle}</strong> to unlock a <strong>FREE GIFT</strong>`;
        }

        // c) gift pin display logic in “away” state
        if (milestoneGift) {
          // show gift pin in pure cart_total, or in both until category is met
          const showGiftMarker =
            FREE_GIFT_PROMOTION_TYPE === 'cart_total' ||
            (FREE_GIFT_PROMOTION_TYPE === 'both' && !qualifiesCategory);
          milestoneGift.style.display = showGiftMarker ? 'block' : 'none';
          milestoneGift.classList.remove('achieved');
        }
      }
    }

    // 9) Inject the combined message
    messageEl.innerHTML = message;

    // 10) Fill bar toward gift threshold (cart_total/both until category) or shipping
    const useGiftMax = ENABLE_FREE_GIFT && (
      FREE_GIFT_PROMOTION_TYPE === 'cart_total' ||
      (FREE_GIFT_PROMOTION_TYPE === 'both' && !cart.items.some(i => QUALIFYING_PRODUCT_IDS.has(i.product_id)))
    );
    const max = useGiftMax ? FREE_ITEM_THRESHOLD : FREE_SHIPPING_THRESHOLD;
    const pct = Math.min((cartTotal / max) * 100, 100);
    barEl.style.width = `${pct}%`;

    // 11) Finally update the subtotal number
    if (!cart.items.length) {
      subtotalEl.innerHTML = `<span>$0.00</span>`;
    } else if (originalTotal > cartTotal) {
      subtotalEl.innerHTML =
        `<span class="price-original">$${(originalTotal/100).toFixed(2)}</span>` +
        `<span class="price-discounted">$${(cartTotal/100).toFixed(2)}</span>`;
    } else {
      subtotalEl.innerHTML = `<span>$${(cartTotal/100).toFixed(2)}</span>`;
    }
  }

  async function cartContainsNonExcludedItems(cart) {
    const excludedProductTypesLower = EXCLUDED_PRODUCT_TYPES.map(type => type.toLowerCase());
  
    for (let item of cart.items) {
      try {
        const productUrl = item.url;
        // Extract product handle from URL
        const handleMatch = productUrl.match(/\/products\/([^/?#]+)/);
        const productHandle = handleMatch ? handleMatch[1] : null;
  
        if (productHandle) {
          const response = await fetch(`/products/${productHandle}.js`);
          const product = await response.json();
          console.log(product);
          console.log(excludedProductTypesLower);
          // Access product type
          const productType = product.type ? product.type.toLowerCase() : '';
  
          // Check if product type is excluded
          const isExcluded = excludedProductTypesLower.includes(productType);
  
          // If the product type is not excluded, return true
          if (!isExcluded) {
            return true;
          }
        } else {
          // If we can't get the product handle, assume it's non-excluded
          return true;
        }
      } catch (error) {
        console.error('Error in cartContainsNonExcludedItems:', error);
        // Assume non-excluded if there's an error
        return true;
      }
    }
  
    // If all items are excluded, return false
    return false;
  }

  function removeFreeGiftIfNeeded(cart) {
    if (!ENABLE_FREE_GIFT) return;

    const hasFreeGift = isFreeGiftInCart(cart);
    let qualifiesForFreeGift = false;

    // Cart-total check (for cart_total or both)
    if ((FREE_GIFT_PROMOTION_TYPE === 'cart_total' || FREE_GIFT_PROMOTION_TYPE === 'both') &&
        cart.total_price >= FREE_ITEM_THRESHOLD) {
      qualifiesForFreeGift = true;
    }

    // Category check (for product_category or both)
    if ((FREE_GIFT_PROMOTION_TYPE === 'product_category' || FREE_GIFT_PROMOTION_TYPE === 'both') &&
        cart.items.some(item => QUALIFYING_PRODUCT_IDS.has(item.product_id))) {
      qualifiesForFreeGift = true;
    }

    // If we have a gift but no longer qualify, remove it
    if (hasFreeGift && !qualifiesForFreeGift) {
      const freeGiftItem = cart.items.find(item =>
        FREE_GIFT_VARIANT_IDS.includes(item.variant_id)
      );
      if (!freeGiftItem) return;

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: freeGiftItem.key, quantity: 0 }),
      })
      .then(() => fetchCartContents())
      .catch(error => console.error('Error removing free gift:', error));
    }
  }


  function renderCartItems(cart) {
    const container       = document.getElementById('cart-drawer-contents');
    const hasFreeGift     = isFreeGiftInCart(cart);

    // Qualification flags
    const qualifiesCart     = cart.total_price >= FREE_ITEM_THRESHOLD;
    const qualifiesCategory = cart.items.some(i => QUALIFYING_PRODUCT_IDS.has(i.product_id));

    // Only show slider if:
    // • free-gift is enabled
    // • they don’t already have a gift
    // • merchant has NOT set a default auto-add product
    // • they qualify by the chosen promo rule
    const shouldShowSlider =
      ENABLE_FREE_GIFT &&
      !hasFreeGift &&
      !(AUTO_ADD_FREE_GIFT && AUTO_ADD_FREE_GIFT_HANDLE) &&
      (
        (FREE_GIFT_PROMOTION_TYPE === 'cart_total'       && qualifiesCart)    ||
        (FREE_GIFT_PROMOTION_TYPE === 'product_category' && qualifiesCategory)||
        (FREE_GIFT_PROMOTION_TYPE === 'both'             && (qualifiesCart || qualifiesCategory))
      );

    const freeGiftSliderHTML = shouldShowSlider
      ? renderFreeGiftSlider()
      : '';  // <-- no slider if auto-add is configured

    const cartItemsHTML   = cart.items.map(item => generateCartItemHTML(item)).join('');
    container.innerHTML = freeGiftSliderHTML + cartItemsHTML;
  }

  function amountToCents(raw) {
    if (raw == null) return 0;
    const s = String(raw).trim();
    const n = Number(s);
    if (Number.isNaN(n)) return 0;
    // If it looks like dollars ("0.00"), convert to cents; if it's an int, assume cents
    return s.includes('.') ? Math.round(n * 100) : n;
  }

  function generateCartItemHTML(item) {
    const isFreeGift =
      FREE_GIFT_VARIANT_IDS.includes(item.variant_id) &&
      item.line_price === 0;

    const discountDetails = (item.line_level_discount_allocations || [])
      .filter(d => amountToCents(d.amount ?? d.money) > 0)
      .map(d => {
        const cents = amountToCents(d.amount ?? d.money);
        return `
          <li class="discount-list-item">
            <span class="discount-title">${d.discount_application.title}</span>
            (-<span class="money">${formatMoney(cents)}</span>)
          </li>`;
      })
      .join('');

    const originalPriceDisplay =
      item.original_line_price > item.line_price
        ? `<span class="price-original">$${(item.original_line_price / 100).toFixed(2)}</span><br>`
        : '';

    const productTitle = isFreeGift
      ? `FREE GIFT: ${item.product_title}`
      : item.product_title;

    const quantitySelector = isFreeGift
      ? ''
      : `
        <div class="d-flex align-items-center">
          <button class="btn btn-outline-secondary btn-sm me-2 qty-btn" onclick="updateCartItemQuantity('${item.key}', ${item.quantity - 1})">-</button>
          <span id="qty-label">${item.quantity}</span>
          <button class="btn btn-outline-secondary btn-sm ms-2 qty-btn" onclick="updateCartItemQuantity('${item.key}', ${item.quantity + 1})">+</button>
        </div>`;

    // ✅ Variant options (multi-option support, skip Default Title)
    let variantTitle = '';
    if (item.options_with_values && item.options_with_values.length) {
      variantTitle = item.options_with_values
        .filter(opt => opt.value && opt.value !== 'Default Title')
        .map(opt => `
          <div class="cart-item__variant text-muted small">
            ${opt.name}: ${opt.value}
          </div>
        `)
        .join('');
    }

    return `
      <div class="cart-item d-flex align-items-center mb-3 ${isFreeGift ? 'free-gift-item' : ''}" data-line-id="${item.key}">
        <a href="${item.url}">
          <img src="${item.image}" alt="${item.title}" class="cart-item__image me-3" style="width: 70px; height: auto;">
        </a>
        <div class="cart-item__details flex-grow-1">
          <h6>
            <a href="${item.url}" class="text-dark text-decoration-none" style="color:#300028 !important">
              ${productTitle}
            </a>
          </h6>
          ${variantTitle} <!-- 👈 shows "Option: Value" for each option -->
          ${quantitySelector}
          ${discountDetails ? `<ul class="discount-list">${discountDetails}</ul>` : ''}
        </div>
        <div class="text-end">
          ${originalPriceDisplay}<span class="price-discounted">$${(item.line_price / 100).toFixed(2)}</span><br>
          <button class="btn btn-link p-0 text-secondary" onclick="removeCartItem('${item.key}')"><i class="bi bi-trash"></i></button>
        </div>
      </div>
    `;
  }



  function renderFreeGiftSlider() {
  const tpl = document.getElementById('free-gift-slides-template');
  const slidesHtml = tpl ? (tpl.innerHTML || '') : '';

  // Populate FREE_GIFT_VARIANT_IDS from the template buttons
  // (so isFreeGiftInCart / removeFreeGiftIfNeeded still work)
  if (tpl && FREE_GIFT_VARIANT_IDS.length === 0) {
    const tmp = document.createElement('div');
    tmp.innerHTML = slidesHtml;
    tmp.querySelectorAll('.select-free-gift').forEach(btn => {
      const vid = Number(btn.getAttribute('data-variant-id'));
      if (vid) FREE_GIFT_VARIANT_IDS.push(vid);
    });
  }

  return `
    <div class="cart-item free-gift-slider-container mb-3">
      <div class="free-gift-header">
        <h6 class="mb-2">🎁 Choose Your Free Gift!</h6>
      </div>
      <div class="free-gift-swiper-wrapper">
        <div class="swiper-container free-gift-swiper">
          <div class="swiper-wrapper">
            ${slidesHtml}
          </div>
          <div class="swiper-pagination free-gift-pagination"></div>
          <div class="swiper-button-prev free-gift-prev" aria-label="Previous free gift"></div>
          <div class="swiper-button-next free-gift-next" aria-label="Next free gift"></div>
        </div>
      </div>
    </div>
  `;
}


  async function renderPairsWellWith(cartProductIds) {
    const products = await fetchPairsWellWithProducts();
    if (!Array.isArray(products)) {
      console.error('renderPairsWellWith: Expected products to be an array');
      return;
    }
  
    // Filter out items already in the cart
    const filtered = products.filter(p => !cartProductIds.includes(p.id));
    if (!filtered.length) return;
  
    // Remove old container if it exists
    const old = document.getElementById('pairs-well-with-container');
    if (old) old.remove();
  
    // Build new container
    const container = document.createElement('div');
    container.id = 'pairs-well-with-container';
    container.classList.add('pairs-well-with-section');
    container.innerHTML = `
      <hr>
      <h5 class="text-center mb-4">PAIRS WELL WITH</h5>
      <div class="product-grid row">
        ${filtered.map(generateProductHTML).join('')}
      </div>
    `;
  
    // Append into the cart drawer
    const cartItems = document.getElementById('cart-drawer-contents');
    if (cartItems) cartItems.appendChild(container);
  
    // Wire up variant dropdowns & add‑to‑cart buttons
    initPairsWellWith();
  }

  async function fetchPairsWellWithProducts() {
    // PAIRS_COLLECTION_HANDLE comes from Liquid
    return await fetchCollectionProducts(PAIRS_COLLECTION_HANDLE, 50);
  }

  /**
  * Turn a raw Shopify variant.price (string or number)
  * into a two‑decimal dollar string.
  */
  function formatPrice(raw) {
    const s = String(raw);
    // If it already has a decimal, assume dollars
    if (s.includes('.')) {
      return parseFloat(s).toFixed(2);
    }
    // Otherwise assume it's integer cents
    return (parseInt(s, 10) / 100).toFixed(2);
  }

  function generateProductHTML(product) {
    // 1) Build a map { variantId: imageUrl, … }
    const variantImageMap = {};
    product.variants.forEach(v => {
      // If this variant has its own featured_image, use that:
      let url = v.featured_image && v.featured_image.src
        ? v.featured_image.src
        // Otherwise fall back to the product’s featured_image or first image
        : product.featured_image
          ? `https:${product.featured_image}`
          : (product.images && product.images[0] && product.images[0].src)
            || '/path-to-default-image.jpg';
      variantImageMap[v.id] = url;
    });
    const variantImagesJson = JSON.stringify(variantImageMap);
  
    // 2) Your existing logic to pick the default image, title, price, etc.
    const imageUrl = product.featured_image
      ? `https:${product.featured_image}`
      : (product.images && product.images[0] && product.images[0].src)
        || '/path-to-default-image.jpg';
    const defaultVariant = product.variants[0];
    const defaultPrice   = formatPrice(defaultVariant.price);
    const defaultCompare = defaultVariant.compare_at_price != null
      ? formatPrice(defaultVariant.compare_at_price)
      : null;
  
    let variantSelectHTML = '';
    if (product.variants.length > 1) {
      const options = product.variants.map(v => `
        <option
          value="${v.id}"
          data-price="${v.price}"
          data-compare="${v.compare_at_price || ''}"
        >
          ${v.title}
        </option>
      `).join('');
      variantSelectHTML = `
        <select
          id="variant-select-${product.id}"
          class="variant-select form-select mb-2"
        >${options}</select>`;
    }
  
    // 3) Embed the map on the wrapper DIV:
    return `
      <div
        class="col-md-6 mb-4 d-flex"
      >
        <div
          class="recommended-product d-flex flex-column justify-content-between text-center p-3 w-100"
          data-product-id="${product.id}"
          data-variant-images='${variantImagesJson}'
        >
          <div>
            <a href="/products/${product.handle}" class="d-block mb-3 text-decoration-none text-dark">
              <img
                src="${imageUrl}"
                alt="${product.title}"
                class="img-fluid mb-2 recommended-product__image"
                style="max-height:150px;object-fit:contain;"
                loading="lazy"
              >
            </a>
            <h6 class="recommended-product__title mb-2">${product.title}</h6>
  
            ${variantSelectHTML}
  
            ${defaultCompare
              ? `<p class="recommended-product__original-price text-muted mb-1"><s>$${defaultCompare}</s></p>`
              : ''
            }
            <p class="recommended-product__discounted-price text-danger mb-3">$${defaultPrice}</p>
          </div>
          <button
            class="btn button-primary btn-sm add-to-cart-btn mt-2"
            data-variant-id="${defaultVariant.id}"
          >
            Add to Cart
          </button>
        </div>
      </div>
    `;
  }

  function initPairsWellWith() {
    // Wire up variant dropdown → price, compare‑at, image & button
    document.querySelectorAll('.variant-select').forEach(select => {
      select.addEventListener('change', e => {
        const sel       = e.currentTarget;
        const card      = sel.closest('.recommended-product');
        const opt       = sel.selectedOptions[0];
        const newVid    = Number(opt.value);
  
        // 1) Update the “sale” price
        const priceRaw  = opt.dataset.price;
        const priceFmt  = formatPrice(priceRaw);
        const priceEl   = card.querySelector('.recommended-product__discounted-price');
        if (priceEl) priceEl.textContent = `$${priceFmt}`;
  
        // 2) Update the “compare at” if needed
        const compRaw = opt.dataset.compare;
        const compEl  = card.querySelector('.recommended-product__original-price');
        if (compRaw) {
          const compFmt = formatPrice(compRaw);
          if (compEl) {
            compEl.innerHTML = `<s>$${compFmt}</s>`;
          } else {
            priceEl.insertAdjacentHTML('beforebegin',
              `<p class="recommended-product__original-price text-muted mb-1"><s>$${compFmt}</s></p>`
            );
          }
        } else if (compEl) {
          compEl.remove();
        }
  
        // 3) Swap the image (if you’ve wired that up)
        try {
          const vMap = JSON.parse(card.dataset.variantImages || '{}');
          if (vMap[newVid]) {
            card.querySelector('.recommended-product__image').src = vMap[newVid];
          }
        } catch {}
  
        // 4) Update the Add‑to‑Cart button
        const btn = card.querySelector('.add-to-cart-btn');
        if (btn) btn.setAttribute('data-variant-id', newVid);
      });
    });
  
    // Re‑use your existing addToCart handler
    document.body.addEventListener('click', e => {
      const btn = e.target.closest('.add-to-cart-btn');
      if (!btn) return;
      e.preventDefault();
      addToCart(btn.getAttribute('data-variant-id'), 1);
    });
  }

  async function renderRecommendations(cart, cartProductIds) {
    if (!cart.items.length) return;

    // 1) Base AI recommendations
    const mostExpensive = cart.items.reduce((a, b) =>
      a.line_price > b.line_price ? a : b
    );
    let recs = [];
    try {
      const data = await fetch(
        `/recommendations/products.json?product_id=${mostExpensive.product_id}&limit=10`
      ).then(r => r.json());
      recs = (data.products || []).filter(p => !cartProductIds.includes(p.id));
    } catch (e) {
      console.error('Error fetching recommendations:', e);
      return;
    }
    if (!recs.length) return;

    // 2) Optionally fetch extras from merchant’s collection
    let extras = [];
    if (
      RECOMMENDATION_COLLECTION_HANDLE &&
      Number.isInteger(RECOMMENDATION_COLLECTION_COUNT) &&
      RECOMMENDATION_COLLECTION_COUNT > 0
    ) {
      extras = await fetchCollectionProducts(
        RECOMMENDATION_COLLECTION_HANDLE,
        RECOMMENDATION_COLLECTION_COUNT
      );
      extras = extras.filter(p => !cartProductIds.includes(p.id));
    }

    // 3) Interleave extras into recs
    let finalList = recs;
    if (extras.length) {
      finalList = [];
      const interval = Math.ceil(recs.length / extras.length);
      let e = 0;
      recs.forEach((r, i) => {
        finalList.push(r);
        if ((i + 1) % interval === 0 && e < extras.length) {
          finalList.push(extras[e++]);
        }
      });
      while (e < extras.length) finalList.push(extras[e++]);
    }

    // 4) Render into the drawer
    const containerId = 'you-may-also-like';
    const old = document.getElementById(containerId);
    if (old) old.remove();

    const wrapper = document.createElement('div');
    wrapper.id = containerId;
    wrapper.innerHTML = `
      <hr>
      <h5 class="text-center mb-4">YOU MAY ALSO LIKE</h5>
      <div class="recommendations-container row">
        ${finalList.map(p => generateProductHTML(p)).join('')}
      </div>
    `;
    document
      .getElementById('cart-drawer-contents')
      .appendChild(wrapper);

    // 5) Attach Add‑to‑Cart handlers (and variant dropdowns if any)
    wrapper.querySelectorAll('.add-to-cart-btn').forEach(btn => {
      btn.addEventListener('click', e => {
        e.preventDefault();
        addToCart(btn.getAttribute('data-variant-id'), 1);
      });
    });
    if (typeof initPairsWellWith === 'function') initPairsWellWith();
  }

  function formatMoney(cents) {
    return `$${(cents / 100).toFixed(2)}`;
  }

  function resetButton(button) {
    const addToCartText = button.querySelector('.atc-button--text');
    const addToCartIcon = button.querySelector('.atc-button--icon');

    if (addToCartText) addToCartText.style.visibility = 'visible';
    if (addToCartIcon) {
      addToCartIcon.style.visibility = 'hidden';
      addToCartIcon.style.opacity = '0';
    }
    button.disabled = false;
  }



  function handleCheckoutClick(event) {
    event.preventDefault();
    document.getElementById('cart-drawer').classList.remove('cart-drawer--open');
    document.getElementById('cart-overlay').style.display = 'none';
    setTimeout(() => {
      window.location.href = '/checkout';
      checkoutButton.disabled = false;
    }, 200);
  }

  // Function to update cart item quantity, ensuring free gift quantity remains 1
  function updateCartItemQuantity(lineItemKey, newQuantity) {
    fetch('/cart.js')
      .then((response) => response.json())
      .then((cart) => {
        const item = cart.items.find((item) => item.key === lineItemKey);
        if (!item) return;

        const isFreeGiftVariant = FREE_GIFT_VARIANT_IDS.includes(item.variant_id);
        if (isFreeGiftVariant) {
          if (newQuantity > 1) {
            alert('Only one free gift can be added to the cart.');
            newQuantity = 1;
          }
        }

        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: lineItemKey, quantity: newQuantity }),
        })
          .then(() => fetch('/cart.js'))
          .then((response) => response.json())
          .then((updatedCart) => {
            removeFreeGiftIfNeeded(updatedCart);
            fetchCartContents();
          })
          .catch((error) => console.error('Error updating item quantity:', error));
      })
      .catch((error) => console.error('Error fetching cart:', error));
  }

  function removeCartItem(lineItemKey) {
    updateCartItemQuantity(lineItemKey, 0);
  }

  function isFreeGiftInCart(cart) {
    return cart.items.some(item =>
        FREE_GIFT_VARIANT_IDS.includes(item.variant_id) &&
        item.line_price === 0
    );
  }

  // The addToCart function
  function addToCart(variantId, quantity = 1) {
    return fetch('/cart.js')
      .then((response) => response.json())
      .then((cart) => {
        const isFreeGiftVariant = FREE_GIFT_VARIANT_IDS.includes(Number(variantId));
        const hasFreeGift = isFreeGiftInCart(cart);

        if (isFreeGiftVariant) {
          if (hasFreeGift) {
            //alert('You have already added a free gift to your cart.');
            //throw new Error('Free gift already in cart');
          }
          if (FREE_GIFT_PROMOTION_TYPE === 'cart_total' && cart.total_price < FREE_ITEM_THRESHOLD) {
            alert('You need to spend more to qualify for this free gift.');
            throw new Error('Cart total does not meet free gift threshold');
          }
          // Force quantity to 1 for free gift
          quantity = 1;
        }

        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity }),
        })
          .then(() => fetch('/cart.js'))
          .then((response) => response.json())
          .then((updatedCart) => {
            removeFreeGiftIfNeeded(updatedCart);
            fetchCartContents();
          })
          .catch((error) => {
            console.error('Error adding item to cart:', error);
            throw error;
          });
      })
      .catch((error) => {
        console.error('Error fetching cart:', error);
        throw error;
      });
  }

  function addFreeGiftToCart(variantId) {
    _justAutoAddedGift = true;

    fetch('/cart.js')
      .then((response) => response.json())
      .then((cart) => {
        if (isFreeGiftInCart(cart)) {
          alert('You have already added a free gift to your cart.');
        } else {
          const selectButtons = document.querySelectorAll('.select-free-gift');
          selectButtons.forEach((button) => {
            button.disabled = true;
            button.style.backgroundColor = 'gray';
            button.style.color = 'white';
          });

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: 1 }),
          })
            .then(() => fetchCartContents())
            .catch((error) => {
              console.error('Error adding free gift to cart:', error);
              _justAutoAddedGift = false; // reset on error
              alert('There was an issue adding your free gift. Please try again.');
              selectButtons.forEach((button) => {
                button.disabled = false;
                button.style.backgroundColor = '';
                button.style.color = '';
              });
            });
        }
      })
      .catch((error) => {
        console.error('Error fetching cart for free gift check:', error);
        alert('There was an issue verifying your cart. Please try again.');
      });
  }

  function handleAddAllSelectedClick(event) {
    event.preventDefault();
    event.stopPropagation();
  
    const button = event.currentTarget;
  
    // Show loading indicator
    const addToCartText = button.querySelector('.atc-button--text');
    const addToCartIcon = button.querySelector('.atc-button--icon');
  
    if (addToCartText) addToCartText.style.visibility = 'hidden';
    if (addToCartIcon) {
      addToCartIcon.style.visibility = 'visible';
      addToCartIcon.style.opacity = '1';
    }
    button.disabled = true;
  
    const fbtContainer = document.querySelector('.complementary-products__container');
    if (fbtContainer) {
      const selectedProducts = Array.from(
        fbtContainer.querySelectorAll('.complementary-product__checkbox:checked')
      ).map((checkbox) => checkbox.value);
  
      if (selectedProducts.length > 0) {
        addMultipleItemsToCart(selectedProducts)
          .then(() => {
            // Reset button state
            if (addToCartText) addToCartText.style.visibility = 'visible';
            if (addToCartIcon) {
              addToCartIcon.style.visibility = 'hidden';
              addToCartIcon.style.opacity = '0';
            }
            button.disabled = false;
  
            // Scroll the cart drawer to the top
            const cartDrawerContents = document.getElementById('cart-drawer-contents');
            if (cartDrawerContents) {
              cartDrawerContents.scrollTop = 0;
            }
          })
          .catch((error) => {
            console.error('Error adding items to cart:', error);
            alert('There was an error adding items to your cart. Please try again.');
  
            // Reset button state in case of error
            if (addToCartText) addToCartText.style.visibility = 'visible';
            if (addToCartIcon) {
              addToCartIcon.style.visibility = 'hidden';
              addToCartIcon.style.opacity = '0';
            }
            button.disabled = false;
          });
      } else {
        alert('Please select at least one item to add to the cart.');
  
        // Reset button state
        if (addToCartText) addToCartText.style.visibility = 'visible';
        if (addToCartIcon) {
          addToCartIcon.style.visibility = 'hidden';
          addToCartIcon.style.opacity = '0';
        }
        button.disabled = false;
      }
    }
  }
  document.addEventListener('DOMContentLoaded', async function () {
    if (ENABLE_FREE_GIFT && (FREE_GIFT_PROMOTION_TYPE === 'product_category' || FREE_GIFT_PROMOTION_TYPE === 'both')) {
      try {
        const prods = await fetchCollectionProducts(QUALIFYING_COLLECTION_HANDLE, 250);
        prods.forEach(p => QUALIFYING_PRODUCT_IDS.add(p.id));
      } catch (err) {
        console.error('Failed to load qualifying-collection:', err);
      }
    }
  });

  // Event Listeners
  document.addEventListener('DOMContentLoaded', function () {
    // Check if we're on a product page using the `shop-js-analytics` script
    const pageTypeElement = document.getElementById('shop-js-analytics');
    const pageData = pageTypeElement ? JSON.parse(pageTypeElement.textContent) : null;

    if (pageData && pageData.pageType === 'product') {
      // Check periodically for the complementary products section
      const maxRetries = 10;
      let retries = 0;

      const interval = setInterval(() => {
        const complementaryContainer = document.querySelector('.complementary-products__container');
        const addToCartButton = document.querySelector('#add-all-selected');

        if (complementaryContainer && addToCartButton) {
          clearInterval(interval); // Stop checking once the container and button are found

          addToCartButton.addEventListener(
            'click',
            async function (event) {
              event.preventDefault(); // Prevent any default form submission
              event.stopImmediatePropagation();

              // Collect selected variant IDs from checkboxes
              const selectedProducts = Array.from(
                complementaryContainer.querySelectorAll('.complementary-product__checkbox')
              )
                .filter((checkbox) => checkbox.checked)
                .map((checkbox) => checkbox.value);

              if (selectedProducts.length === 0) {
                alert('Please select at least one item to add to the cart.');
                return;
              }

              const addToCartText = addToCartButton.querySelector('.atc-button--text');
              const addToCartIcon = addToCartButton.querySelector('.atc-button--icon');

              if (addToCartText) addToCartText.style.display = 'none';
              if (addToCartIcon) {
                addToCartIcon.style.display = 'block';
                addToCartIcon.style.opacity = '1';
              }
              addToCartButton.disabled = true;

              console.log(selectedProducts.length);
              // Disable fetchCartContents temporarily
              const originalFetchCartContents = window.fetchCartContents;
              window.fetchCartContents = function () {};

              // Disable the button and add items to cart
              addToCartButton.disabled = true;

              try {
                // Sequentially add each item to cart
                for (const variantId of selectedProducts) {
                  await addToCart(variantId, 1, false); // Suppress drawer each time
                }
                // Re-enable fetchCartContents and open the drawer
                window.fetchCartContents = originalFetchCartContents;
                fetchCartContents();
              } catch (error) {
                console.error('Error adding complementary products to cart:', error);
              } finally {
                addToCartButton.disabled = false;
                addToCartIcon.style.display = 'none';
                addToCartIcon.style.opacity = '0';
                addToCartText.style.display = 'block';
              }
            },
            true
          );
        } else if (++retries >= maxRetries) {
          clearInterval(interval); // Stop checking after max retries
        }
      }, 500); // Check every 500ms
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    // Cart Icon Click
    const cartIcon = document.querySelector('.site-header-cart--button');
    if (cartIcon) {
      cartIcon.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        fetchCartContents();
      });
    }
    
    // Free Gift Selection
    if (ENABLE_FREE_GIFT) {
      document.getElementById('cart-drawer-contents').addEventListener('click', function (event) {
        if (event.target.classList.contains('select-free-gift')) {
          event.preventDefault();
          event.stopPropagation();
          const variantId = event.target.getAttribute('data-variant-id');
          if (variantId) addFreeGiftToCart(variantId);
        }
      });
    }

    document.body.addEventListener(
      'click',
      function (event) {
        const button = event.target.closest('.add-to-cart-btn');
        if (button) {
          event.preventDefault();
          event.stopPropagation();
    
          const originalButtonText = button.innerHTML; // Save the original button content
          button.disabled = true;
          button.innerHTML = '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>';
    
          const variantId = button.getAttribute('data-variant-id');
          if (variantId) {
            addToCart(variantId)
              .then(() => {
                // Scroll the cart drawer to the top after adding to cart
                const cartDrawerContents = document.getElementById('cart-drawer-contents');
                if (cartDrawerContents) {
                  cartDrawerContents.scrollTop = 0;
                }
    
                // Re-enable the button and reset its text
                button.disabled = false;
                button.innerHTML = originalButtonText;
              })
              .catch((error) => {
                console.error('Error adding item to cart:', error);
                // Re-enable the button and reset its text in case of error
                button.disabled = false;
                button.innerHTML = originalButtonText;
              });
          } else {
            // Re-enable the button and reset its text if variantId is missing
            button.disabled = false;
            button.innerHTML = originalButtonText;
          }
        }
      },
      true
    );

    document.body.addEventListener(
      'click',
      function (event) {
        const button = event.target.closest('.productitem--action-atc');
        if (button) {
          // Get the button text
          const addToCartTextElement = button.querySelector('.atc-button--text');
          const buttonText = addToCartTextElement ? addToCartTextElement.textContent.trim() : '';

          // If button text is "Choose options", do not proceed with add to cart
          if (buttonText === 'Choose options') {
            // Allow the default behavior (e.g., navigating to the product page)
            return;
          }

          event.preventDefault();
          event.stopPropagation();

          const variantId = button.getAttribute('data-variant-id');
          let quantity = 1; // Default quantity to 1

          // Check if variant is a free gift variant
          const isFreeGiftVariant = FREE_GIFT_VARIANT_IDS.includes(Number(variantId));
          if (isFreeGiftVariant) {
            // Ensure quantity is 1
            quantity = 1;
          }

          if (variantId) {
            // Show spinner, hide "Add to Cart" text
            if (addToCartTextElement) addToCartTextElement.style.visibility = 'hidden';
            const addToCartIcon = button.querySelector('.atc-button--icon');
            if (addToCartIcon) {
              addToCartIcon.style.visibility = 'visible';
              addToCartIcon.style.opacity = '1';
            }
            button.disabled = true;

            addToCart(variantId, quantity)
              .catch((error) => console.error('Error adding item to cart:', error))
              .finally(() => {
                // Reset button state after cart action completes
                resetButton(button);
              });
          } else {
            alert('Please select a variant.');
            resetButton(button); // Ensure the button is reset in case of error
          }
        }
      },
      true
    );

    // Form Submission for Product Pages and Quick Add Modal
    document.addEventListener(
      'submit',
      function (event) {
        const form = event.target.closest('form[data-product-form]');
        if (form) {
          event.preventDefault();
          event.stopPropagation();

          // Get the add-to-cart button within the form
          const button = form.querySelector('.product-form--atc-button');
          const addToCartText = button?.querySelector('.atc-button--text');
          const addToCartIcon = button?.querySelector('.atc-button--icon');

          // Get the variant ID from the variant-selection element
          const variantSelection = form.querySelector('variant-selection[data-variant-selection]');
          const variantId = variantSelection ? variantSelection.getAttribute('variant') : null;

          const quantityInput = form.querySelector('input[name="quantity"]');
          let quantity = quantityInput ? parseInt(quantityInput.value) : 1;

          // Check if variant is a free gift variant
          const isFreeGiftVariant = FREE_GIFT_VARIANT_IDS.includes(Number(variantId));
          if (isFreeGiftVariant) {
            if (quantity > 1) {
              alert('Only one free gift can be added to the cart.');
              quantity = 1;
              if (quantityInput) quantityInput.value = 1; // Reset quantity input to 1
            }
          }

          // Show spinner, hide "Add to Cart" text
          if (addToCartText) addToCartText.style.visibility = 'hidden';
          if (addToCartIcon) {
            addToCartIcon.style.visibility = 'visible';
            addToCartIcon.style.opacity = '1';
          }
          if (button) button.disabled = true;

          // Ensure a variant is selected
          if (variantId === 'not-selected' || !variantId) {
            alert('Please select a variant.');
            if (button) resetButton(button);
            return;
          }

          // Add item to cart if a valid variant is selected
          addToCart(variantId, quantity)
            .then(() => {
              // Check if the form is inside a modal
              const isInModal = !!form.closest('.modal--quickshop-slim, .quick-add-modal, .modal--product');
              if (isInModal) {
                // Close the quick add modal after adding to cart
                closeQuickAddModal();
              }
            })
            .catch((error) => console.error('Error adding item to cart:', error))
            .finally(() => {
              // Reset button state after cart action completes
              if (button) resetButton(button);
            });
        }
      },
      true
    );

    function closeQuickAddModal() {
      // Adjust the selector to match your quick add modal's class or ID
      const modalElement = document.querySelector('.modal--quickshop-slim, .quick-add-modal, .modal--product');
  
      if (modalElement) {
        // If there's a close button, simulate a click on it
        const closeButton = modalElement.querySelector('[data-modal-close], .modal__close-button');
        if (closeButton) {
          closeButton.click();
        } else {
          // If no close button, hide the modal directly
          modalElement.classList.remove('is-visible');
          modalElement.style.display = 'none';
  
          // Remove any overlay or background scroll lock if necessary
          const body = document.body;
          body.classList.remove('modal-open');
          body.style.overflow = '';
        }
      }
    }
  });

  function addMultipleItemsToCart(variantIds) {
    const items = variantIds.map((variantId) => ({ id: variantId, quantity: 1 }));
  
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items }),
    })
      .then((response) => response.json())
      .then(() => {
        // Refresh the cart contents
        return fetchCartContents();
      })
      .catch((error) => {
        console.error('Error adding items to cart:', error);
        throw error; // Re-throw the error to be caught in the event handler
      });
  }
    const { body } = document;
    const html = document.documentElement;
  
    function _blockScroll(event) {
        // Only block events that occur outside the modal
        if (event.target.closest('.allow-scroll-while-locked')) return;
        event.preventDefault();
        event.stopPropagation();
    }
  
    class ScrollLock {
        /**
        * Locks background scroll and allows scrolling only within the specified modal element
        * @param {HTMLElement} modal Element within which scrolling is allowed
        */
        static lock(modal) {
            if (modal) {
                modal.classList.add('allow-scroll-while-locked');
            }
  
            // Lock scroll on the <html> element
            html.classList.add('scroll-locked');
  
            // Save the current scroll position
            body.style.top = `-${window.pageYOffset}px`;
  
            // Block scroll and touch events outside the modal
            body.addEventListener('scroll', _blockScroll, false);
            body.addEventListener('touchmove', _blockScroll, { passive: false });
        }
  
        /**
        * Removes scroll lock and restores the previous scroll position
        */
        static unlock() {
            // Remove modal-specific scroll allowance
            document.querySelectorAll('.allow-scroll-while-locked').forEach(modal => modal.classList.remove('allow-scroll-while-locked'));
  
            // Unlock scroll on the <html> element
            html.classList.remove('scroll-locked');
  
            // Restore the original scroll position
            const scrollY = body.style.top;
            body.style.top = '';
            window.scrollTo(0, parseInt(scrollY || '0') * -1);
  
            // Remove scroll and touch event listeners
            body.removeEventListener('scroll', _blockScroll, false);
            body.removeEventListener('touchmove', _blockScroll, { passive: false });
        }
  
        /**
        * Checks if scroll is currently locked
        * @returns {boolean} True if scroll is locked
        */
        static get isLocked() {
            return html.classList.contains('scroll-locked');
        }
    }

    function handleIOSAndChromePadding() {
      const userAgent = navigator.userAgent;
      const body = document.body;
    
      // Detect iOS devices
      const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
    
      // Detect Chrome on iOS
      const isChromeOnIOS = /CriOS/.test(userAgent) && isIOS;
    
      if (isIOS) {
        // Add the 'ios' class to the body
        body.classList.add('ios');
      }
    
      if (isChromeOnIOS) {
        // Add both 'ios' and 'chrome' classes for Chrome on iOS
        body.classList.add('chrome');
        console.log('Chrome on iOS detected: Added chrome class to body.');
      } else if (isIOS) {
        console.log('iOS detected (not Chrome). Added ios class to body.');
      } else {
        console.log(`Non-iOS browser detected. User Agent: ${userAgent}`);
      }
    }
    
    // Call the function on page load
    window.addEventListener('load', handleIOSAndChromePadding);